/**
 * 提供外层注入属性的context
 */
import { createContext } from 'react';
import defaultConfig from './defaultConfig';
var ConfigContext = /*#__PURE__*/createContext(defaultConfig);
export default ConfigContext;